package com.merkost.handpass.api.dto.report

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UserReportResponse(
    val id: String,
    @SerialName("reported_user_id") val reportedUserId: String,
    @SerialName("reporter_id") val reporterId: String,
    val reason: String,
    val details: String? = null,
    val status: String = "pending",
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("reported_user_name") val reportedUserName: String? = null,
    @SerialName("reported_user_avatar") val reportedUserAvatar: String? = null,
    @SerialName("reporter_name") val reporterName: String? = null
)

@Serializable
data class CreateUserReportRequest(
    val reason: String,
    val details: String? = null
)
